import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import ArenaxLayout from './ArenaxLayout';
import { Calendar, MapPin, Sparkles } from 'lucide-react';

export default function ArenaxPlayerBookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/arenax/player/bookings')
      .then(r => setBookings(r.data.bookings || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <ArenaxLayout>
      <section className="max-w-5xl mx-auto px-5 sm:px-8 py-10" data-testid="arenax-bookings-page">
        <div className="mb-8">
          <div className="text-[11px] tracking-[0.4em] text-cyan-300 font-bold mb-2">YOUR HISTORY</div>
          <h1 className="text-3xl sm:text-4xl font-black text-slate-100">My Bookings</h1>
        </div>
        {loading ? (
          <div className="text-center text-slate-500 py-12">Loading...</div>
        ) : bookings.length === 0 ? (
          <div className="rounded-3xl border border-dashed border-cyan-500/20 p-14 text-center">
            <Sparkles className="h-10 w-10 text-cyan-400/50 mx-auto mb-4" />
            <h3 className="text-lg font-bold text-slate-200 mb-2">No bookings yet</h3>
            <p className="text-sm text-slate-500 mb-6">Pick your first venue and lock a slot.</p>
            <Link to="/arenax/venues">
              <button className="px-6 py-3 rounded-xl text-sm font-bold text-slate-950"
                style={{ background: 'var(--ax-primary-gradient)' }}>
                Discover Venues
              </button>
            </Link>
          </div>
        ) : (
          <div className="space-y-3">
            {bookings.map(b => (
              <div key={b.id} className="rounded-2xl border border-slate-800 p-5"
                style={{ background: 'linear-gradient(160deg, rgba(8,145,178,0.10), var(--ax-card-bg-soft))' }}
                data-testid={`arenax-booking-${b.id}`}>
                <div className="flex flex-wrap items-start justify-between gap-4 mb-3">
                  <div>
                    <div className="text-sm font-bold text-slate-100">{b.booking_code} · <span className="text-cyan-300">{b.sport}</span></div>
                    <div className="text-xs text-slate-500 mt-0.5 flex items-center gap-1"><Calendar className="h-3 w-3" />{(b.slots_snapshot || [])[0]?.date}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-lg font-black text-slate-100">₹{b.total_amount}</div>
                    <div className={`text-[10px] uppercase tracking-wider font-bold ${
                      b.status === 'confirmed' ? 'text-emerald-400' : b.status === 'pending_payment' ? 'text-amber-400' : 'text-slate-500'
                    }`}>{b.status?.replace('_', ' ')}</div>
                  </div>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                  {(b.slots_snapshot || []).map(s => (
                    <div key={s.id} className="text-[11px] px-2 py-1.5 rounded-md bg-slate-900/60 border border-slate-800 text-slate-300">
                      {s.start_time}–{s.end_time} · ₹{s.price}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </ArenaxLayout>
  );
}
